module.exports = __webpack_public_path__ + "img/img-login.cd6fbc87.png";